/**
 @ngdoc directive
 @name xmsFilters

 @param
 {url=} url if it's not specified the listingModel.filtersData needs to be initialized in the content (xms-listing response) with ng-init!
 */
(function() {
  'use strict'

  const xmsFilters = ($timeout, $sce, $templateCache, ajaxCall, timestampUrl, errorMsgFactory) => {
    return {
      restrict: 'EA',
      scope: true,
      bindToController: {
        url: '@xmsFilters',
        listingModel: '=',
        refresh: '=',
      },
      priority: 100,
      controllerAs: 'ctrl',
      controller: ['$scope', '$element', function($scope, $element) {

        const that = this
        let dontFocusAfterReload = true
        let cancelModelWatch
        let ajaxFilterUpdate

        this.$onInit = () => {

          if (!angular.isDefined(that.listingModel)) that.listingModel = {}
          $scope.model = { filters: {} }

          $scope.filterLabelToYesNo = filterLabel => {
            let label
            switch (filterLabel.toUpperCase()) {
              case 'TRUE':
                label = 'Yes'
                break
              case 'FALSE':
                label = 'No'
                break
              default:
                label = filterLabel
            }
            return label
          }

          ajaxFilterUpdate = that.url !== ''

          if (ajaxFilterUpdate) {
            that.createFiltersUrl()

            // refresh filters
            $scope.$watch(
              () => {
                return that.refresh
              }, (newVal, oldVal) => {
                // noinspection JSIncompatibleTypesComparison
                if (newVal !== oldVal) {
                  dontFocusAfterReload = true
                  that.createFiltersUrl()
                }
              },
            )
          } else {
            $timeout(() => { // we need to wait for ng-init to kick off
              that.initBackendFilters()
            })
          }
        }

        const scrollTop = timeMs => {
          $('body,html').animate({ scrollTop: 0 }, timeMs, 'swing')
        }

        const createFiltersModel = filtersData => {
          // model init (instead of previous ng-init)
          const modelFilters = {}
          angular.forEach(filtersData, filterGroup => {
            angular.forEach(filterGroup.filters, filter => {
              if (typeof filter.checked !== 'boolean') {
                console.warn('Not boolean value "' + filter.checked + '" used instead of expected boolean for filter ' + filter.value)
              }
              modelFilters[filter.value] = filter.checked && filter.count !== 0
            })
          })
          return modelFilters
        }

        // because of Advanced Search design we need to pass count as a part of listingModel.filters id property!!!!
        // please mind (in case of problems) its only updated when $scope.model.filters changes
        const copyWithCountAdded = (filtersData, filtersModel) => {
          const listingModelFilters = {}
          angular.forEach(filtersData, filterGroup => {
            angular.forEach(filterGroup.filters, filter => {
              if (filter.count) {
                listingModelFilters[filter.value + '|' + filter.count] = filtersModel[filter.value]
              } else {
                listingModelFilters[filter.value] = filtersModel[filter.value]
              }
            })
          })
          return listingModelFilters
        }

        const initModelWatch = () => {
          let modelChangeTimer
          return $scope.$watchCollection(
            scope => {
              return scope.model.filters
            }, (newVal, oldVal) => {
              // noinspection JSIncompatibleTypesComparison
              if (newVal !== oldVal) {
                $timeout.cancel(modelChangeTimer)
                modelChangeTimer = $timeout(() => {
                  if (ajaxFilterUpdate) {
                    that.listingModel.filters = angular.copy($scope.model.filters)
                    that.createFiltersUrl()
                  } else {
                    that.listingModel.filters = copyWithCountAdded(that.listingModel.filtersData, $scope.model.filters)
                  }
                }, 1000) // TODO: 1000 into ng-model-options config
              }
            },
          )
        }

        this.createFiltersUrl = () => {
          $scope.loading = true
          $scope.loadingError = false

          // temporarily cancel model watch so createFunction is not called in the loop
          if (typeof cancelModelWatch === 'function') cancelModelWatch()

          scrollTop(250)

          let query = ''
          if (angular.isDefined(that.listingModel.filters)) {
            query = '&filterUserAction=true&hdnIsLoaded=false&' + jQuery.param(that.listingModel.filters)
          }

          ajaxCall.getData(timestampUrl.add(that.url), query).then(
            result => {
              console.log('-----filters loaded-----')
              const filtersData = result.data.filterGroups
              if (angular.isDefined(filtersData) &&
                angular.isDefined(filtersData[filtersData.length - 1]) &&
                angular.isDefined(filtersData[filtersData.length - 1].paramField)) {
                $scope.someParametersWeNeverUse = filtersData.pop() // that's how the json data is built
              }
              $scope.loading = false
              that.listingModel.filtersData = filtersData

              // model init (instead of previous ng-init)
              $scope.model.filters = createFiltersModel(filtersData)
              that.listingModel.filters = angular.copy($scope.model.filters)

              cancelModelWatch = initModelWatch()
              if (!dontFocusAfterReload) {
                $element.focus() // accessibility focus after reload
                scrollTop(0)
              } else {
                dontFocusAfterReload = false
              }

              $timeout(() => {
                that.listingModel.filtersInitiallyLoaded = true
              })
            },
            result => {
              $scope.loading = false
              $scope.loadingError = $sce.trustAsHtml(errorMsgFactory.connectionError(result))
            },
          )
        }

        // Advanced Search case - initialized in the xmsListing (response) content with ng-init
        this.initBackendFilters = () => {

          if (!angular.isDefined(that.listingModel.filtersData) || angular.equals(that.listingModel.filtersData, {})) {
            throw 'Please define url (xms-filters) or ng-init filters error!'
          }

          $scope.model.filters = createFiltersModel(that.listingModel.filtersData)
          that.listingModel.filters = copyWithCountAdded(that.listingModel.filtersData, $scope.model.filters)
          initModelWatch()

          $timeout(() => {
            that.listingModel.filtersInitiallyLoaded = true
          })
        }
      }],
      replace: true,
      transclude: false,
      template: $templateCache.get('components/listing/xmsFilters.html'),
      link: scope => {

        scope.collapseOrExpand = () => {
          if (angular.isDefined(scope.listingModel.disableFacets) &&
            scope.listingModel.disableFacets === true)
            return false
          else {
            let collapsedCount = 0
            angular.forEach(scope.model.filterCollapsed, val => {
              collapsedCount = val === true ? collapsedCount + 1 : collapsedCount
            })
            return Object.keys(scope.model.filterCollapsed).length / 2 > collapsedCount
          }
        }

        scope.expandCollapseAll = () => {
          // if more than half is expanded it will collapse all, otherwise expand
          const collapseOrExpand = scope.collapseOrExpand()
          angular.forEach(scope.model.filterCollapsed, (val, key) => {
            scope.model.filterCollapsed[key] = !!collapseOrExpand
          })
        }

        scope.loadFilters = () => {
          if (angular.isDefined(scope.listingModel.disableFacets) && scope.listingModel.disableFacets === true) {
            scope.listingModel.refresh = scope.listingModel.refresh + 1
            scope.listingModel.disableFacets = false
          }
        }
      },
    }
  }

  xmsFilters.$inject = ['$timeout', '$sce', '$templateCache', 'ajaxCall', 'timestampUrl', 'errorMsgFactory']
  angular.module('app').directive('xmsFilters', xmsFilters)
// eslint-disable-next-line semi
}());
